var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStandard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 60.1367H60.75V0.136719H0.75V60.1367Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45801 48.0462H37.7356C40.1491 48.0462 42.1058 46.0939 42.1058 43.676V15.9148L27.2491 1.03125H11.8282C9.41472 1.03125 7.45801 2.98349 7.45801 5.4014V48.0462Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45801 48.0462H37.7356C40.1491 48.0462 42.1058 46.0939 42.1058 43.676V15.9148L27.2491 1.03125H11.8282C9.41472 1.03125 7.45801 2.98349 7.45801 5.4014V48.0462Z",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0968 15.879H31.6192C29.2057 15.879 27.249 13.9268 27.249 11.5089V1.03125L42.0968 15.879Z",
    fill: "#BBDDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0968 15.879H31.6192C29.2057 15.879 27.249 13.9268 27.249 11.5089V1.03125L42.0968 15.879Z",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45743 5.98438H6.87534C4.47893 6.00229 2.54549 7.94557 2.54102 10.3456V48.6292C2.55534 51.0202 4.48609 52.9545 6.87534 52.9724H32.7828C33.9416 52.9724 35.0538 52.5157 35.8733 51.6918C36.6927 50.8769 37.153 49.7575 37.153 48.6023V48.0471H11.8276C9.41415 48.0471 7.45743 46.0948 7.45743 43.6769V5.98438Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45743 5.98438H6.87534C4.47893 6.00229 2.54549 7.94557 2.54102 10.3456V48.6292C2.55534 51.0202 4.48609 52.9545 6.87534 52.9724H32.7828C33.9416 52.9724 35.0538 52.5157 35.8733 51.6918C36.6927 50.8769 37.153 49.7575 37.153 48.6023V48.0471H11.8276C9.41415 48.0471 7.45743 46.0948 7.45743 43.6769V5.98438Z",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8281 29.0884H25.0102",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8281 21.3345H30.4998",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8281 25.2095H30.4998",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.757 41.0867L50.187 33.8667C49.724 33.3967 49.094 33.1367 48.437 33.1367C47.78 33.1367 47.15 33.3967 46.687 33.8667C46.222 34.3267 45.96 34.9567 45.96 35.6167C45.96 36.2767 46.222 36.9067 46.687 37.3667L46.767 37.4467L46.687 37.3667L44.887 35.6267C44.424 35.1567 43.794 34.8967 43.137 34.8967C42.48 34.8967 41.85 35.1567 41.387 35.6267C41.119 35.9067 40.924 36.2567 40.817 36.6267V38.1867C40.924 38.5567 41.119 38.9067 41.387 39.1867L43.217 41.0167L41.387 39.1867L40.887 38.5667L39.707 37.3867C39.244 36.9167 38.614 36.6567 37.957 36.6567C37.3 36.6567 36.67 36.9167 36.207 37.3867C35.742 37.8467 35.48 38.4767 35.48 39.1367C35.48 39.7967 35.742 40.4267 36.207 40.8867L39.747 44.5067L36.167 40.9267L30.977 35.7367C30.514 35.2667 29.884 35.0067 29.227 35.0067C28.57 35.0067 27.94 35.2667 27.477 35.7367C27.012 36.1967 26.75 36.8267 26.75 37.4867C26.75 38.1467 27.012 38.7767 27.477 39.2367L37.007 48.7667L40.637 52.3967L31.837 53.7767C30.338 53.9767 29.224 55.2667 29.237 56.7767C29.248 57.7267 30.022 58.4967 30.977 58.5067H47.517C49.843 58.5067 52.073 57.5767 53.717 55.9367L56.477 53.1767C59.786 49.8667 59.914 44.5467 56.767 41.0867H56.757Z",
    fill: "#BBDDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.757 41.0867L50.187 33.8667C49.724 33.3967 49.094 33.1367 48.437 33.1367C47.78 33.1367 47.15 33.3967 46.687 33.8667C46.222 34.3267 45.96 34.9567 45.96 35.6167C45.96 36.2767 46.222 36.9067 46.687 37.3667L46.767 37.4467L46.687 37.3667L44.887 35.6267C44.424 35.1567 43.794 34.8967 43.137 34.8967C42.48 34.8967 41.85 35.1567 41.387 35.6267C41.119 35.9067 40.924 36.2567 40.817 36.6267V38.1867C40.924 38.5567 41.119 38.9067 41.387 39.1867L43.217 41.0167L41.387 39.1867L40.887 38.5667L39.707 37.3867C39.244 36.9167 38.614 36.6567 37.957 36.6567C37.3 36.6567 36.67 36.9167 36.207 37.3867C35.742 37.8467 35.48 38.4767 35.48 39.1367C35.48 39.7967 35.742 40.4267 36.207 40.8867L39.747 44.5067L36.167 40.9267L30.977 35.7367C30.514 35.2667 29.884 35.0067 29.227 35.0067C28.57 35.0067 27.94 35.2667 27.477 35.7367C27.012 36.1967 26.75 36.8267 26.75 37.4867C26.75 38.1467 27.012 38.7767 27.477 39.2367L37.007 48.7667L40.637 52.3967L31.837 53.7767C30.338 53.9767 29.224 55.2667 29.237 56.7767C29.248 57.7267 30.022 58.4967 30.977 58.5067H47.517C49.843 58.5067 52.073 57.5767 53.717 55.9367L56.477 53.1767C59.786 49.8667 59.914 44.5467 56.767 41.0867H56.757Z",
    fill: "#BBDDFF",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/Standard.c008f8b487d41a12d2a10fd64b32fa8c.svg";
export { ForwardRef as ReactComponent };